<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6EUC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <!--<div class="clearfix detail-block">-->
                
              <div class="clearfix detail-block">  
                <div class="detail-field-float detail-field-left border-color-skin clearfix">
                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['200'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codinput" name="coddesc_codinput">{{ detail.tab1.codinput }} - {{ detail.tab1.desc_codinput }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['10'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                    </div>
                  </div>
                </div>

                <div class="detail-field-float detail-field-right border-color-skin clearfix">
                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['20'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['30'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="dtework" name="dtework">{{ setDateOutput(detail.tab1.dtework) }}</div>
                    </div>
                  </div>               
                </div>
              </div>

              <div class="clearfix detail-block">
                <div class="detail-block-float detail-block-left">
                  <div class="detail-header">{{ labels['HRES6EUC3']['40'] }}</div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['50'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="typwrko" name="typwrko">{{ detail.tab1.typwrko }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['60'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="typwrkn" name="typwrkn">{{ detail.tab1.typwrkn }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['70'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codshifto" name="coddesc_codshifto">{{ detail.tab1.codshifto }} - {{ detail.tab1.desc_codshifto }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['80'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codshiftn" name="coddesc_codshiftn">{{ detail.tab1.codshiftn }} - {{ detail.tab1.desc_codshiftn }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['90'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="timwoe_btw" name="timwoe_btw">{{ detail.tab1.timstrtwoe }} - {{ detail.tab1.timendwoe }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['100'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="timwe_btw" name="timwe_btw">{{ detail.tab1.timstrtwe }} - {{ detail.tab1.timendwe }}</div>
                    </div>
                  </div>   
                </div>

                <div class="detail-block-float detail-block-right">
                  <div class="detail-header">{{ labels['HRES6EUC3']['110'] }}</div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['120'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="typwrkro" name="typwrkro">{{ detail.tab1.typwrkro }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['130'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="typwrkrn" name="typwrkrn">{{ detail.tab1.typwrkrn }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['140'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codshifro" name="coddesc_codshifro">{{ detail.tab1.codshifro }} - {{ detail.tab1.desc_codshifro }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['150'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codshifrn" name="coddesc_codshifrn">{{ detail.tab1.codshifrn }} - {{ detail.tab1.desc_codshifrn }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['160'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="timwor_btw" name="timwor_btw">{{ detail.tab1.timstrtwor }} - {{ detail.tab1.timendwor }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES6EUC3']['170'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="timwr_btw" name="timwr_btw">{{ detail.tab1.timstrtwr }} - {{ detail.tab1.timendwr }}</div>
                    </div>
                  </div>   
                </div>
              </div>
           
              <div class="detail-field-float detail-field-left border-color-skin clearfix">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6EUC3']['180'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100 txtarea-width response-full-width" id="remark" name="remark">{{ detail.tab1.remark }}</div>
                  </div>
                </div>
              </div>
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6EUC4']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body" v-if="detail.tab1.codempid">
            <hrms-calendar-work-time :codempid="detail.tab1.codempid" />
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import hrmsCalendarWorkTime from 'components/hrmsCalendarWorkTime/component'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6eu-detail',
  props: [ 'labels', 'detail', 'toggle', 'data', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    hrmsCalendarWorkTime
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?8b015a6e